import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './CookiesBanner.scss';

const STORAGE_KEY = 'cookieConsent';

const CookiesBanner = () => {
	const [visible, setVisible] = useState(false);

	useEffect(() => {
		const consent = window.localStorage.getItem(STORAGE_KEY);
		if (!consent) {
			setVisible(true);
		}
	}, []);

	const handleChoice = (value) => {
		window.localStorage.setItem(STORAGE_KEY, value);
		setVisible(false);
	};

	if (!visible) {
		return null;
	}

	return (
		<div className='cookies-banner' role='dialog' aria-live='polite' aria-label='Cookie consent notice'>
			<div className='cookies-content'>
				<p className='cookies-text'>
					We use cookies to improve your browsing experience, personalize content, and analyze our traffic. You can learn more in our&nbsp;
					<Link to='/privacy' className='cookies-link'>Privacy Policy</Link>.
				</p>
				<div className='cookies-actions'>
					<button type='button' className='cookies-btn secondary' onClick={() => handleChoice('declined')}>
						Decline
					</button>
					<button type='button' className='cookies-btn primary' onClick={() => handleChoice('accepted')}>
						Accept
					</button>
				</div>
			</div>
		</div>
	);
};

export default CookiesBanner;
